import sortProductionTeam from "astrid-firestore/src/api/productions/team/sortProductionTeam";

export default function getProductionTeamMembers(production) {
	return Object.values(production?.team || {})
		.filter((member) => member.user)
		.sort(sortProductionTeam);
}
